function SessionExpiredModal({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-icon">⏰</div>
        <div className="modal-title">Session Expired</div>
        <div className="modal-sub">
          Your session has expired. Please sign in again to continue.
        </div>
        <button className="btn btn-primary btn-block" onClick={onClose}>
          Sign In Again
        </button>
      </div>
    </div>
  );
}

export default SessionExpiredModal;
